function isEmptyObject(obj): boolean {
  return (
    obj && // 👈 null and undefined check
    Object.keys(obj).length === 0 &&
    Object.getPrototypeOf(obj) === Object.prototype
  );
}

function stringToNumber(v): number {
  let rtn = v;

  if (v != null && (typeof v === "string" || v instanceof String)) {
    if (v.substring(v.length - 1, v.length) == ",") {
      rtn = v.split(",").join(".");
    } else if (isNaN(Number(v))) rtn = v.substring(0, v.length - 1);
    if (v.length > 4) rtn = v.substring(0, v.length - 1);
  }

  return rtn;
}

function capitalizeFirstLetter(string: string): string {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

function confirmRemove(documentTitle, message = null) {
  return confirm(message ?? `Anda yakin menghapus ${documentTitle} ini?`);
}

function isJsonStr(str) {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
}

export {
  isEmptyObject,
  stringToNumber,
  capitalizeFirstLetter,
  confirmRemove,
  isJsonStr
};
